import styles from "./Buttons.module.css";

const ActionButton = ({ icon, text, disabled, onClick }) => {
  return (
    <button
      disabled={disabled}
      className={styles.actionButton}
      onClick={onClick}
    >
      {icon && <img alt={text} src={icon} />}
    </button>
  );
};

export default ActionButton;
